module.exports = __webpack_public_path__ + "../front/img/doors-only-thumb.6de63ad6.jpg";